import _typeof from "@babel/runtime/helpers/typeof";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useCallback, useMemo, useState } from 'react';
import { formErrorContext, formStateContext, formStateRefs } from '../context';
/**
 * Controls state of a single Field
 * @internal
 */

export var FormStateController = function FormStateController(_ref) {
  var children = _ref.children;
  var errorState = useState(undefined);

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      values = _useState2[0],
      setValues = _useState2[1];

  var valuesUpdater = useCallback(function (key, value) {
    return setValues(function (oldState) {
      return _objectSpread(_objectSpread({}, oldState), {}, _defineProperty({}, key, value));
    });
  }, []);
  var valuesContextValue = useMemo(function () {
    return [values, valuesUpdater];
  }, [values, valuesUpdater]);

  var _useState3 = useState({}),
      _useState4 = _slicedToArray(_useState3, 2),
      refs = _useState4[0],
      setRefs = _useState4[1];

  var refsUpdater = useCallback(function (key, value) {
    return setRefs(function (oldState) {
      if (!value) {
        var removeThis = oldState[key],
            newState = _objectWithoutProperties(oldState, [key].map(_toPropertyKey));

        return newState;
      } else {
        return _objectSpread(_objectSpread({}, oldState), {}, _defineProperty({}, key, value));
      }
    });
  }, []);
  var refContextValue = useMemo(function () {
    return [refs, refsUpdater];
  }, [refs, refsUpdater]);
  return /*#__PURE__*/React.createElement(formErrorContext.Provider, {
    value: errorState
  }, /*#__PURE__*/React.createElement(formStateContext.Provider, {
    value: valuesContextValue
  }, /*#__PURE__*/React.createElement(formStateRefs.Provider, {
    value: refContextValue
  }, children)));
};